import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldCheck, Wallet, Lock } from "lucide-react";

export function RoleDescriptions({ compact = false }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/master/roles/info").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div className={compact ? "space-y-2" : "grid md:grid-cols-2 gap-3"} data-testid="role-descriptions">
      {d.roles.filter((r) => r.role !== "pending").map((r) => (
        <div key={r.role} className="surface p-4 space-y-2" data-testid={`role-desc-${r.role}`}>
          <div className="flex items-center justify-between gap-2"><p className="font-semibold text-sm flex items-center gap-1"><ShieldCheck className="h-3.5 w-3.5 text-primary" />{r.label}</p>
            <span className={`text-[10px] rounded-full px-2 py-0.5 flex items-center gap-1 ${r.permissions.includes("money") ? "bg-emerald-100 text-emerald-800" : "bg-muted text-muted-foreground"}`}>{r.permissions.includes("money") ? <><Wallet className="h-3 w-3" />Akses keuangan</> : <><Lock className="h-3 w-3" />Tanpa keuangan</>}</span></div>
          <p className="text-xs text-muted-foreground leading-relaxed">{r.desc}</p>
          {!compact && <>
            <div className="flex flex-wrap gap-1">{r.permissions.map((p) => <span key={p} className="text-[10px] rounded bg-primary/10 text-primary px-1.5 py-0.5">{d.permission_labels[p] || p}</span>)}</div>
            {r.stages && (r.stages === "semua" || r.stages.length > 0) && <p className="text-[11px] text-muted-foreground">Tahap pipeline yang boleh diubah: <b>{r.stages === "semua" ? "semua tahap" : r.stages.join(", ")}</b></p>}
          </>}
        </div>
      ))}
    </div>
  );
}
